<div class="upsell-product-box-full">
  <div class="upsell-product-box-full__container mx-auto w-full">
    <div class="upsell-product-box-full__title-wrapper flex justify-center w-full">
      <div class="upsell-product-box-full__title-content w-full text-center p-4 mx-auto my-4 text-white text-3xl font-normal uppercase" [innerHTML]="title"></div>
    </div>
    
    <div class="upsell-product-box-full__product-wrapper flex justify-center relative w-full mb-4">
      <div class="upsell-product-box-full__product-content w-full px-4 pt-4 mx-auto flex">
        <div class="upsell-product-box-full__product-content-flex mx-auto w-full flex flex-row">
          
          <div class="upsell-product-box-full__additional-image-wrapper desktop:w-1/2 pt-4 flex justify-center items-end">
            <img class="upsell-product-box-full__additional-image w-full h-auto block" src="{{ additionalImage }}" alt="{{ imageAlt }}">
          </div>
          
          <div class="upsell-product-box-full__content-wrapper w-full desktop:w-1/2 flex flex-col justify-center pt-10">
            <img class="upsell-product-box-full__image max-h-80 self-center block mx-auto max-w-full order-2" src="{{ image }}" alt="">
            <div class="upsell-product-box-full__price-wrapper notranslate order-1">
              <p class="upsell-product-box-full__regularPrice text-left text-xl">{{regularText}}: {{ regularPrice | dynamicCurrency:currency }}</p>
              <p class="upsell-product-box-full__instantSavings text-left text-xl">{{instantSavingsText}}: {{ instantSavings | dynamicCurrency:currency }}</p>
              <p class="upsell-product-box-full__yourPrice text-left text-xl">{{yourPriceText}}: {{ yourPrice | dynamicCurrency:currency }} {{ currency !== 'USD' ? currency : '' }}</p> 
            </div>
          </div>
        </div>
      </div>
      <div class="upsell-product-box-full__triangle"></div>
    </div>
  </div>
</div>
